import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { color } from 'utils/functions/colors'

export const ConfidentialUpdate = styled(FontAwesomeIcon)`
  color: ${color('lightGray')};
  font-size: 1.3rem;
`
